export default __webpack_public_path__ + "static/11-dd458d8899a2664abc40dba0934cff39.webp";